<template>
  <div class="main-container">
    <div class="main-page">
      <div class="main-page__left">
        <main-menu></main-menu>
      </div>
      <div class="main-page__right">
        <div class="">
          <div class="choosing-arenas">
            <h2 class="main-title">
              Choose Partner for edit
              <span v-if="chosenPartner">or</span>
              <span
                class="create-arena-link"
                v-if="chosenPartner"
                @click="showCreateForm"
              >Create new</span>
            </h2>
            <ul class="selectable-list arena-list-container">
              <li class="selectable-list__item"
                  v-for="(partner, i) in partners"
                  :class="{'active': (chosenPartner && partner) && (chosenPartner === partner)}"
                  :key="partner + i"
                  @click="selectPartner(partner)"
              >
                <p><strong>{{partner.name}}</strong></p>
              </li>
            </ul>
          </div>
        </div>

        <Loader v-if="isDataLoadInProgress"></Loader>

        <div v-else class="arena-form">
          <div v-if="chosenPartner">
            <div class="tab-content">
                <EditForm
                  :partner="chosenPartner"
                  v-on:partner-edited="getData"
                ></EditForm>
            </div>
          </div>

          <CreateForm
            v-else
            v-on:partner-created="getData"
          ></CreateForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreateForm from '../CreateForm/CreateForm.vue'
import EditForm from '../EditForm/EditForm.vue'
import Loader from '../../Loader/Loader.vue'
import config from '../../../config'
import MainMenu from '../../MainMenu/MainMenu.vue'

export default {
  components: { MainMenu, CreateForm, EditForm, Loader },
  name: 'PartnersPage',
  data () {
    return {
      chosenPartner: null,
      isDataLoadInProgress: false,
      partners: []
    }
  },
  created: function () {
    this.getData()
  },
  methods: {
    showCreateForm: function () {
      this.chosenPartner = null
    },
    getData: function () {
      this.isDataLoadInProgress = true
      this.chosenPartner = null
      Promise.all([this.getPartners()])
        .then(_ => {
          this.isDataLoadInProgress = false
        }, error => {
          console.log(error)
          this.isDataLoadInProgress = false
        })
    },
    getPartners: function () {
      return this.$http.get(`${config.apiUrl}/partners/model/list`).then(response => {
        this.partners = response.body
      }, error => {
        console.log(error)
      })
    },
    selectPartner: function (partner) {
      this.chosenPartner = partner
    }
  }
}
</script>

<style scoped src="./partnersPage.scss" lang="scss"></style>
